import { render, staticRenderFns } from "./contactCreate.vue?vue&type=template&id=290b4b32&"
import script from "./contactCreate.vue?vue&type=script&lang=js&"
export * from "./contactCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports